export const isSafariDesktop = () => {
  const userAgent = navigator.userAgent.toLowerCase();
  const isSafari = /^((?!chrome|android).)*safari/i.test(userAgent);
  const isDesktop = !/mobile|android|iphone|ipad|tablet/i.test(userAgent);

  return isSafari && isDesktop;
};
